export default "__VITE_ASSET__cfcDpgf9__"